import moment from 'moment';

export default (date) => {
    if (date) {
        return moment(String(date)).format('MM/DD/YYYY');
    }
};